
<!-- Blog -->
<section class="our-articles bg-light-theme section-padding pt-0">
  <div class="blog-page-banner"></div>
  <div class="container-fluid">
    <div class="row">
      <aside class="col-lg-3">
        <app-blogleftsidebar
          [posts]="allPosts"
          [selectedTag]="selectedTag"
          (tagSelected)="onTagSelected($event)"
        ></app-blogleftsidebar>
      </aside>
      <div class="col-lg-6 blog-inner clearfix">
        <div class="main-box padding-20 full-width">
          <div class="breadcrumb-wrpr">
            <ul class="breadcrumb">
              <li class="breadcrumb-item">
                <a routerLink="/" class="text-light-black">Home</a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">Blog</li>
            </ul>
          </div>

          <div
            *ngIf="selectedTag"
            class="filter-indicator mb-xl-20"
            style="
              padding: 12px 16px;
              background-color: #f0f8ff;
              border-left: 3px solid hsl(0.41deg, 75.51%, 38.43%);
              border-radius: 4px;
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <span class="text-light-black">
              Filtered by tag: <strong>#{{ selectedTag }}</strong>
              <span class="text-light-white" style="margin-left: 8px"
                >({{ posts.length }} {{ posts.length === 1 ? 'post' : 'posts' }})</span
              >
            </span>
            <button
              type="button"
              (click)="onTagSelected(null)"
              (touchend)="onTagSelected(null); $event.preventDefault()"
              style="
                background: none;
                border: none;
                color: hsl(0.41deg, 75.51%, 38.43%);
                cursor: pointer;
                font-size: 14px;
                padding: 4px 8px;
                touch-action: manipulation;
                min-height: 44px;
                text-decoration: underline;
              "
              title="Clear filter"
            >
              Clear filter
            </button>
          </div>

          <ng-container *ngIf="!isLoading && posts.length; else blogState">
            <div class="row">
              <div
                class="col-xl-6 col-lg-12 col-sm-6"
                *ngFor="let post of posts; trackBy: trackByPostId"
              >
                <article class="blog-services-wrapper main-box mb-xl-20">
                  <div class="post-img">
                    <a [routerLink]="['/blog-details', post.id]">
                      <img
                        [src]="post.afterPhotoUrl || post.beforePhotoUrl"
                        class="img-fluid full-width"
                        [alt]="post.storeName || 'post'"
                      />
                    </a>
                  </div>
                  <div class="post-meta">
                    <div class="author-img">
                      <img
                        [src]="post.userInfo?.photoUrl"
                        class="rounded-circle"
                        [alt]="post.userInfo?.name || 'Author'"
                      />
                    </div>
                    <div class="author-meta">
                      <h6 class="no-margin">
                        <span class="text-light-black">
                          {{ post.userInfo?.name || 'Unknown Author' }}
                        </span>
                      </h6>
                      <p class="no-margin text-light-white">
                        <span class="text-light-white">{{ post.storeName }}</span>
                        |
                        <span>{{ post.createdTime | date: 'longDate' }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="post-content padding-20">
                    <h5>
                      <a [routerLink]="['/blog-details', post.id]" class="text-light-black">
                        {{ post.description || 'View post' }}
                      </a>
                    </h5>
                    <p>
                      {{ post.topics?.join(', ') || post.storeName || 'Recent post' }}
                    </p>
                    <div class="blog-link-wrap">
                      <a [routerLink]="['/blog-details', post.id]" class="btn-first white-btn">Learn More</a>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </ng-container>

          <ng-template #blogState>
            <!-- Loading Skeleton -->
            <div class="row" *ngIf="isLoading">
              <div class="col-xl-6 col-lg-12 col-sm-6" *ngFor="let i of [1,2,3,4,5,6]">
                <article class="blog-services-wrapper main-box mb-xl-20">
                  <div class="post-img">
                    <div class="skeleton-image" style="width: 100%; height: 220px; border-radius: 4px;"></div>
                  </div>
                  <div class="post-meta">
                    <div class="author-img">
                      <div class="skeleton-image img-rounded" style="width: 40px; height: 40px;"></div>
                    </div>
                    <div class="author-meta">
                      <div class="skeleton-text" style="width: 150px; height: 16px; margin-bottom: 8px;"></div>
                      <div class="skeleton-text" style="width: 200px; height: 14px;"></div>
                    </div>
                  </div>
                  <div class="post-content padding-20">
                    <div class="skeleton-text" style="width: 80%; height: 20px; margin-bottom: 12px;"></div>
                    <div class="skeleton-text" style="width: 100%; height: 16px; margin-bottom: 8px;"></div>
                    <div class="skeleton-text" style="width: 70%; height: 16px; margin-bottom: 16px;"></div>
                    <div class="skeleton-text" style="width: 120px; height: 36px; border-radius: 4px;"></div>
                  </div>
                </article>
              </div>
            </div>
            <div class="py-4 text-center" *ngIf="!isLoading && error">
              <p class="text-light-black mb-2">{{ error }}</p>
              <button class="btn btn-sm btn-primary" (click)="loadPosts()">Try again</button>
            </div>
            <div class="py-4 text-center" *ngIf="!isLoading && !error && !posts.length">
              <p class="text-light-black mb-0">
                {{ selectedTag ? 'No posts found for tag #' + selectedTag + '.' : 'No posts found.' }}
              </p>
              <button
                *ngIf="selectedTag"
                type="button"
                class="btn btn-sm btn-primary mt-3"
                (click)="onTagSelected(null)"
                (touchend)="onTagSelected(null); $event.preventDefault()"
                style="touch-action: manipulation; min-height: 44px;"
              >
                Clear filter
              </button>
            </div>
          </ng-template>
        </div>
      </div>
      <aside class="col-lg-3">
        <app-blogrightsidebar [posts]="posts"></app-blogrightsidebar>
      </aside>
    </div>
  </div>
</section>
